import PropTypes from "prop-types";

function P2TrackerItem({ stage, isActive }) {
  const { label, description, link } = stage;
  const activeClass = isActive ? "active" : "inactive"

  return (
    <>   
      <div className="polymer-tracker-item__bullet-container" >
        <div className={`polymer-tracker-item__bullet-point polymer-tracker-item__bullet-point-${activeClass}`}/>
        <div className={`polymer-tracker-item__line polymer-tracker-item__line-${activeClass}`}/>
      </div>
      <div>
        <span className={`polymer-tracker-item__label polymer-tracker-item__label-${activeClass}`}>{label}</span>
        <div>
          {description && <span className={`polymer-tracker-item__desc polymer-tracker-item__desc-${activeClass}`}>{description}</span>}
          {link && (
            <>
              <span className={`polymer-tracker-item__desc polymer-tracker-item__desc-${activeClass}`}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
              <a className="polymer-tracker-item__link" href={link}>
                View document &gt;
              </a>
            </>
          )}
        </div>
      </div>
    </>
  );
}

P2TrackerItem.propType = {
  stage: PropTypes.shape({
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    link: PropTypes.string,
  }),
};

export default P2TrackerItem;
